import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=a5c27af2&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=a5c27af2&prod&scoped=true&lang=css"
import style1 from "./Article.vue?vue&type=style&index=1&id=a5c27af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c27af2",
  null
  
)

export default component.exports